<template><div>hh</div></template>

<script>
import AppState from '@/store/App.js';
export default {
  activated() {
    AppState.isLoading = false;
  }
};
</script>

<style></style>
